import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { AuthService } from '../../_services/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from 'src/app/app.component';
import { ToastrService } from 'src/app/_services/toastr.service';
import { Router } from '@angular/router';
import { HomeComponent } from '../home.component';
import Swal from 'sweetalert2';
declare var $;
declare function GenerateQRCode(params): any;

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
})
export class ProfileComponent implements OnInit {
  // tslint:disable-next-line: max-line-length
  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private router: Router,
    private appComponent: AppComponent,
    private toastrService: ToastrService,
    private homeComponent: HomeComponent
  ) {}

  ngOnInit() {
    
  }


}
